/* eslint-disable */
/**
 * validateItemLimits — validates that leasable items do not exceed
 * the maximum allowed count (4) or total quantity (4).
 *
 * Used before proceeding to pricing/funding to enforce item limits.
 */

const MAX_ITEMS = 4;

export interface ItemLimitValidation {
  valid: boolean;
  itemCount: number;
  totalQuantity: number;
  errorMessage?: string;
}

/**
 * Validates that the given leasable items array does not exceed item limits.
 * - Item count must be ≤ 4
 * - Total quantity (sum of all items' quantities, defaulting to 1 if not specified) must be ≤ 4
 *
 * @param leasableItems Array of leasable item objects with optional `quantity` field
 * @returns Validation result with item count, total quantity, and error message if invalid
 */
export function validateItemLimits(leasableItems: any[]): ItemLimitValidation {
  const itemCount = leasableItems.length;
  const totalQuantity = leasableItems.reduce(
    (sum: number, item: any) => sum + (Number(item.quantity) || 1),
    0
  );

  if (itemCount > MAX_ITEMS) {
    return {
      valid: false,
      itemCount,
      totalQuantity,
      errorMessage: `Too many items detected (${itemCount}). Maximum allowed is ${MAX_ITEMS}. Please reduce your cart to ${MAX_ITEMS} items or fewer and try again.`,
    };
  }

  if (totalQuantity > MAX_ITEMS) {
    return {
      valid: false,
      itemCount,
      totalQuantity,
      errorMessage: `Total quantity across all items is ${totalQuantity}. Maximum allowed is ${MAX_ITEMS}. Please reduce quantities and try again.`,
    };
  }

  return {
    valid: true,
    itemCount,
    totalQuantity,
  };
}
